import { meetingRoomBookingService } from '@/services/app/meetingRoomBooking.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { meetingRoomBookingModel } from '@/models/app/meetingRoomBooking.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    occupied: [],
    status: {
        list: true,
        save: true,
        occupied: true,
    },
};

export const MEETING_ROOM_BOOKING_MODULE = "app/meetingRoomBooking";

// ACTIONS
export const GET_ALL_MEETING_ROOM_BOOKING = 'getAllMeetingRoomBooking';
export const DELETE_MEETING_ROOM_BOOKING = 'deleteMeetingRoomBooking';
export const SHOW_ALL_MEETING_ROOM_BOOKING = 'showAllMeetingRoomBooking';
export const CREATE_MEETING_ROOM_BOOKING = 'createMeetingRoomBooking';

// MUTATIONS
const REQUESTING = "requesting";
const OCCUPIED_MEETING_ROOM_BOOKING_SUCCESS = "occupiedMeetingRoomBookingSuccess";
const ALL_MEETING_ROOM_BOOKING_SUCCESS = "allMeetingRoomBookingSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [SHOW_ALL_MEETING_ROOM_BOOKING]({commit}, {filter}) {
        commit(REQUESTING, 'occupied');
        return meetingRoomBookingService
            .showAllBooking(filter)
            .then((result) => {
                commit(OCCUPIED_MEETING_ROOM_BOOKING_SUCCESS, result);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [CREATE_MEETING_ROOM_BOOKING]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return meetingRoomBookingService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [GET_ALL_MEETING_ROOM_BOOKING]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return meetingRoomBookingService
            .getAll(filter)
            .then((result) => {
                commit(ALL_MEETING_ROOM_BOOKING_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [DELETE_MEETING_ROOM_BOOKING]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return meetingRoomBookingService
            .destroy(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.deleteXSuccess', [])});
                commit(SUCCESS);
                dispatch(GET_ALL_MEETING_ROOM_BOOKING, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [OCCUPIED_MEETING_ROOM_BOOKING_SUCCESS](state, result) {
        state.occupied = result.success ? (result.data || []).map(item => meetingRoomBookingModel(item)) : [];
    },
    [ALL_MEETING_ROOM_BOOKING_SUCCESS](state, {data}) {
        let meetingRoomBookingList = data.data || [];
        state.list.data = meetingRoomBookingList;
        if (data.pagination) state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = meetingRoomBookingList.map(item => meetingRoomBookingModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            save: true,
        occupied: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            save: true,
        occupied: true,
        };
    },
};
